import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '@app/store/root-state';
import { Observable } from 'rxjs';
import { fetchAllRider, toggleHandled } from '@app/store/faxe/rider/rider.actions';
import {
  selectRiderByRaceGuid,
} from '@app/store/faxe/rider/rider.selector';
import { Rider } from '@app/rest-client/faxe/models/rider';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';

@Injectable({
  providedIn: 'root'
})
export class RiderFacadeService {

  constructor(private store: Store<RootState>) {
  }

  fetchRiders(raceGuid: string, issuer: string, requiredSliceState: SliceState): void {
    this.store.dispatch(
      fetchAllRider(
        { raceGuid: raceGuid, requiredSliceState, issuerStack: [issuer] }));
  }

  toggleHandled(riderId: string, isHandled: boolean, issuer: string) {
    this.store.dispatch(
      toggleHandled(
        { riderGuid: riderId, isHandled, issuerStack: [issuer] }));
  }

  selectRiderByRaceGuid(raceGuid: string, requiredSliceState: SliceState): Observable<Rider[]> {
    return this.store.pipe(
      select(selectRiderByRaceGuid(raceGuid, requiredSliceState))
    );
  }

}
